export default __webpack_public_path__ + "static/media/turkey_dark_female.5868f1da.png";